import React from 'react';
import { Route, Redirect } from 'react-router-dom'
import qs from 'query-string';
import { connect } from 'react-redux';
import { authSuccess, authFail } from '../../redux/actions/authActions';

class Authorize extends Route {
  render() {

    const { jwt } = qs.parse(this.props.location.search);

    if (jwt) {
      this.props.onAuthenticate(jwt);
      return <Redirect to="/" />
    } else {
      this.props.onAuthenticateError();
      return <Redirect to="/login" />
    }
  }
}

const mapStateToProps = (state) => {
  return { auth: state.auth };
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAuthenticate: (jwt) => dispatch(authSuccess(jwt)),
    onAuthenticateError: () => dispatch(authFail())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Authorize);